import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "icad-results-desktop-table" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "icad-results-desktop-table__heading" }, "Incident Reporting", -1)
const _hoisted_3 = {
  key: 0,
  class: "icad-results-desktop-table__results-summary"
}
const _hoisted_4 = { class: "icad-results-desktop-table__results-summary__search" }
const _hoisted_5 = { class: "icad-results-desktop-table__results-summary__open" }
const _hoisted_6 = { class: "icad-results-desktop-table__clear-sort" }
const _hoisted_7 = { class: "mobile-sort d-flex d-md-none flex-row align-items-center px-3 mb-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "sortByDD",
  class: "me-2"
}, "Sort by:", -1)
const _hoisted_9 = ["value"]
const _hoisted_10 = ["value"]
const _hoisted_11 = ["value"]
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "icad-results-desktop-table__header d-none flex-row d-md-flex row" }
const _hoisted_21 = { class: "icad-results-desktop-table__events d-flex flex-column" }
const _hoisted_22 = { class: "icad-results-desktop-table__table d-flex flex-column" }
const _hoisted_23 = {
  key: 0,
  class: "icad-results-desktop-table__no-results-table d-flex flex-column"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", { class: "icad-results-desktop-table__results-summary__noResults" }, [
  /*#__PURE__*/_createTextVNode(" Your search returned "),
  /*#__PURE__*/_createElementVNode("span", { class: "icad-results-desktop-table__results-summary__open" }, " 0 incidents ")
], -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "icad-results-desktop-table__help" }, " Edit your search criteria and try again. ", -1)
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericTableHeaderButton = _resolveComponent("GenericTableHeaderButton")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!
  const _component_IcadResultsTableIncident = _resolveComponent("IcadResultsTableIncident")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.hasResults && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.searchResultsString) + " ", 1),
            _createElementVNode("span", _hoisted_5, " (" + _toDisplayString(_ctx.eventStore.getOpenEvents) + " Open) ", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_GenericTableHeaderButton, {
          class: "clear-sort d-none d-md-flex",
          label: "CLEAR SORT",
          sortable: false,
          onFieldClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.sortBy(_ctx.defaultSort)))
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("select", {
          name: "sortByDD",
          id: "sortByDD",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.sortByModel) = $event)),
          class: "form-control w-auto"
        }, [
          _createElementVNode("option", { value: _ctx.defaultSort }, "Default", 8, _hoisted_9),
          _createElementVNode("option", { value: _ctx.cadSortAsc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.cadSortAsc)), 9, _hoisted_10),
          _createElementVNode("option", { value: _ctx.cadSortDesc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.cadSortDesc)), 9, _hoisted_11),
          _createElementVNode("option", { value: _ctx.typeSortAsc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.typeSortAsc)), 9, _hoisted_12),
          _createElementVNode("option", { value: _ctx.typeSortDesc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.typeSortDesc)), 9, _hoisted_13),
          _createElementVNode("option", { value: _ctx.startSortAsc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.startSortAsc)), 9, _hoisted_14),
          _createElementVNode("option", { value: _ctx.startSortDesc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.startSortDesc)), 9, _hoisted_15),
          _createElementVNode("option", { value: _ctx.addressSortAsc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.addressSortAsc)), 9, _hoisted_16),
          _createElementVNode("option", { value: _ctx.addressSortDesc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.addressSortDesc)), 9, _hoisted_17),
          _createElementVNode("option", { value: _ctx.resultSortAsc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.resultSortAsc)), 9, _hoisted_18),
          _createElementVNode("option", { value: _ctx.resultSortDesc }, _toDisplayString(_ctx.getLabelForSelectOption(_ctx.resultSortDesc)), 9, _hoisted_19)
        ], 512), [
          [_vModelSelect, _ctx.sortByModel]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(_component_GenericTableHeaderButton, {
        class: "cad",
        label: _ctx.cadSortAsc.sortField,
        sortable: true,
        sortDirection: _ctx.getSortDirection(_ctx.cadSortAsc),
        onFieldClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortBy(_ctx.cadSortAsc)))
      }, null, 8, ["label", "sortDirection"]),
      _createVNode(_component_GenericTableHeaderButton, {
        class: "type",
        label: _ctx.typeSortAsc.sortField,
        sortable: true,
        sortDirection: _ctx.getSortDirection(_ctx.typeSortAsc),
        onFieldClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortBy(_ctx.typeSortAsc)))
      }, null, 8, ["label", "sortDirection"]),
      _createVNode(_component_GenericTableHeaderButton, {
        class: "start",
        label: _ctx.startSortAsc.sortField,
        sortable: true,
        sortDirection: _ctx.getSortDirection(_ctx.startSortAsc),
        onFieldClicked: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortBy(_ctx.startSortAsc)))
      }, null, 8, ["label", "sortDirection"]),
      _createVNode(_component_GenericTableHeaderButton, {
        class: "address",
        label: _ctx.addressSortAsc.sortField,
        sortable: true,
        sortDirection: _ctx.getSortDirection(_ctx.addressSortAsc),
        onFieldClicked: _cache[5] || (_cache[5] = ($event: any) => (_ctx.sortBy(_ctx.addressSortAsc)))
      }, null, 8, ["label", "sortDirection"]),
      _createVNode(_component_GenericTableHeaderButton, {
        class: "result",
        label: _ctx.resultSortAsc.sortField,
        sortable: true,
        sortDirection: _ctx.getSortDirection(_ctx.resultSortAsc),
        onFieldClicked: _cache[6] || (_cache[6] = ($event: any) => (_ctx.sortBy(_ctx.resultSortAsc)))
      }, null, 8, ["label", "sortDirection"]),
      _createVNode(_component_GenericTableHeaderButton, {
        class: "actions",
        label: "Actions",
        sortable: false
      })
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(_component_LoadingSpinner, {
        class: "event-table-spinner",
        loadingState: "eventsLoading"
      }),
      _createElementVNode("div", _hoisted_22, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventStore.getSortedEvents, (incident, i) => {
          return (_openBlock(), _createBlock(_component_IcadResultsTableIncident, {
            key: i,
            cadNumber: incident.cadNumber,
            type: incident.eventTypeCode,
            startDate: incident.addedDate,
            address: incident.addressCombinedText,
            result: incident.eventResultText,
            state: incident.eventOpenState
          }, null, 8, ["cadNumber", "type", "startDate", "address", "result", "state"]))
        }), 128)),
        (!_ctx.hasResults && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_26))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}